/**
 * @generated SignedSource<<92bdb807656ee9628ec155201f9807de>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type MetadataNoteTemplate$data = {
  readonly author: {
    readonly __typename: string;
    readonly isViewer?: boolean;
    readonly " $fragmentSpreads": FragmentRefs<"TemplateAuthor_Author">;
  } | null;
  readonly externalUrl: string | null;
  readonly summary: string;
  readonly tags: ReadonlyArray<string>;
  readonly title: string;
  readonly " $fragmentSpreads": FragmentRefs<"StarButtonNoteTemplate">;
  readonly " $fragmentType": "MetadataNoteTemplate";
};
export type MetadataNoteTemplate$key = {
  readonly " $data"?: MetadataNoteTemplate$data;
  readonly " $fragmentSpreads": FragmentRefs<"MetadataNoteTemplate">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "MetadataNoteTemplate",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "summary",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "tags",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "externalUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "author",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "__typename",
          "storageKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isViewer",
              "storageKey": null
            }
          ],
          "type": "User",
          "abstractKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "TemplateAuthor_Author"
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "StarButtonNoteTemplate"
    }
  ],
  "type": "NoteTemplateNode",
  "abstractKey": null
};

(node as any).hash = "14e0f26d8be60514c030acd17d149d76";

export default node;
